import { ForecastDayItem } from "../types/weatherApiTypes";

export const dummyForecastData: ForecastDayItem[] = [
  {
    date: "2023-04-22",
    date_epoch: 1,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
      },
    },
  },
  {
    date: "2023-04-23",
    date_epoch: 2,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 23.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
      },
    },
  },
  {
    date: "2023-04-24",
    date_epoch: 3,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 24.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
      },
    },
  },
  {
    date: "2023-04-25",
    date_epoch: 4,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 25.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
      },
    },
  },
  {
    date: "2023-04-26",
    date_epoch: 5,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 26.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
      },
    },
  },
  {
    date: "2023-04-27",
    date_epoch: 6,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
      },
    },
  },
  {
    date: "2023-04-28",
    date_epoch: 7,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
      },
    },
  },
  {
    date: "2023-04-29",
    date_epoch: 8,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
      },
    },
  },
  {
    date: "2023-04-30",
    date_epoch: 9,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
      },
    },
  },
  {
    date: "2023-05-01",
    date_epoch: 10,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
      },
    },
  },
  {
    date: "2023-05-02",
    date_epoch: 11,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
      },
    },
  },
  {
    date: "2023-05-03",
    date_epoch: 12,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
      },
    },
  },
  {
    date: "2023-05-04",
    date_epoch: 13,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
      },
    },
  },
  {
    date: "2023-05-05",
    date_epoch: 14,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
      },
    },
  },
  {
    date: "2023-05-06",
    date_epoch: 15,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
      },
    },
  },
  {
    date: "2023-05-07",
    date_epoch: 16,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
      },
    },
  },
  {
    date: "2023-05-08",
    date_epoch: 17,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
      },
    },
  },
  {
    date: "2023-05-09",
    date_epoch: 18,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
      },
    },
  },
  {
    date: "2023-05-10",
    date_epoch: 19,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
      },
    },
  },
  {
    date: "2023-05-11",
    date_epoch: 20,
    hour: [
      {
        time_epoch: 1651100400,
        time: "2023-04-28 00:00",
        temp_c: 6.2,
        temp_f: 43.2,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 5.4,
        wind_kph: 8.6,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 12,
        feelslike_c: 4.4,
        feelslike_f: 39.9,
        windchill_c: 4.4,
        windchill_f: 39.9,
        heatindex_c: 6.2,
        heatindex_f: 43.2,
        dewpoint_c: 2.0,
        dewpoint_f: 35.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651104000,
        time: "2023-04-28 01:00",
        temp_c: 6.0,
        temp_f: 42.8,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 32,
        wind_dir: "NNE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 6,
        feelslike_c: 4.3,
        feelslike_f: 39.7,
        windchill_c: 4.3,
        windchill_f: 39.7,
        heatindex_c: 6.0,
        heatindex_f: 42.8,
        dewpoint_c: 1.7,
        dewpoint_f: 35.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651107600,
        time: "2023-04-28 02:00",
        temp_c: 5.8,
        temp_f: 42.4,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 4.9,
        wind_kph: 7.9,
        wind_degree: 35,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 75,
        cloud: 3,
        feelslike_c: 4.1,
        feelslike_f: 39.4,
        windchill_c: 4.1,
        windchill_f: 39.4,
        heatindex_c: 5.8,
        heatindex_f: 42.4,
        dewpoint_c: 1.6,
        dewpoint_f: 34.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 1.0,
      },
      {
        time_epoch: 1651111200,
        time: "2023-04-28 03:00",
        temp_c: 5.9,
        temp_f: 42.6,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.0,
        wind_kph: 9.7,
        wind_degree: 39,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.4,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 76,
        cloud: 8,
        feelslike_c: 3.8,
        feelslike_f: 38.8,
        windchill_c: 3.8,
        windchill_f: 38.8,
        heatindex_c: 5.9,
        heatindex_f: 42.6,
        dewpoint_c: 1.9,
        dewpoint_f: 35.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.0,
        gust_kph: 17.6,
        uv: 1.0,
      },
      {
        time_epoch: 1651114800,
        time: "2023-04-28 04:00",
        temp_c: 5.6,
        temp_f: 42.1,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 46,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.41,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 78,
        cloud: 10,
        feelslike_c: 3.1,
        feelslike_f: 37.6,
        windchill_c: 3.1,
        windchill_f: 37.6,
        heatindex_c: 5.6,
        heatindex_f: 42.1,
        dewpoint_c: 2.1,
        dewpoint_f: 35.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.9,
        gust_kph: 19.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651118400,
        time: "2023-04-28 05:00",
        temp_c: 5.3,
        temp_f: 41.5,
        is_day: 0,
        condition: {
          text: "Clear",
          icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
          code: 1000,
        },
        wind_mph: 6.5,
        wind_kph: 10.4,
        wind_degree: 41,
        wind_dir: "NE",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 83,
        cloud: 10,
        feelslike_c: 2.9,
        feelslike_f: 37.2,
        windchill_c: 2.9,
        windchill_f: 37.2,
        heatindex_c: 5.3,
        heatindex_f: 41.5,
        dewpoint_c: 2.7,
        dewpoint_f: 36.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 1.0,
      },
      {
        time_epoch: 1651122000,
        time: "2023-04-28 06:00",
        temp_c: 6.1,
        temp_f: 43.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 47,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 80,
        cloud: 84,
        feelslike_c: 3.6,
        feelslike_f: 38.5,
        windchill_c: 3.6,
        windchill_f: 38.5,
        heatindex_c: 6.1,
        heatindex_f: 43.0,
        dewpoint_c: 2.9,
        dewpoint_f: 37.2,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.7,
        gust_kph: 17.3,
        uv: 2.0,
      },
      {
        time_epoch: 1651125600,
        time: "2023-04-28 07:00",
        temp_c: 7.8,
        temp_f: 46.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 53,
        wind_dir: "NE",
        pressure_mb: 1031.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 70,
        cloud: 100,
        feelslike_c: 5.6,
        feelslike_f: 42.1,
        windchill_c: 5.6,
        windchill_f: 42.1,
        heatindex_c: 7.8,
        heatindex_f: 46.0,
        dewpoint_c: 2.8,
        dewpoint_f: 37.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 2.0,
      },
      {
        time_epoch: 1651129200,
        time: "2023-04-28 08:00",
        temp_c: 9.3,
        temp_f: 48.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 58,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 34,
        feelslike_c: 7.3,
        feelslike_f: 45.1,
        windchill_c: 7.3,
        windchill_f: 45.1,
        heatindex_c: 9.3,
        heatindex_f: 48.7,
        dewpoint_c: 3.0,
        dewpoint_f: 37.4,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651132800,
        time: "2023-04-28 09:00",
        temp_c: 10.6,
        temp_f: 51.1,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 7.4,
        wind_kph: 11.9,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 54,
        feelslike_c: 9.1,
        feelslike_f: 48.4,
        windchill_c: 9.1,
        windchill_f: 48.4,
        heatindex_c: 10.6,
        heatindex_f: 51.1,
        dewpoint_c: 3.1,
        dewpoint_f: 37.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.5,
        gust_kph: 13.7,
        uv: 4.0,
      },
      {
        time_epoch: 1651136400,
        time: "2023-04-28 10:00",
        temp_c: 12.1,
        temp_f: 53.8,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 63,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 55,
        cloud: 25,
        feelslike_c: 11.0,
        feelslike_f: 51.8,
        windchill_c: 11.0,
        windchill_f: 51.8,
        heatindex_c: 12.1,
        heatindex_f: 53.8,
        dewpoint_c: 3.2,
        dewpoint_f: 37.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.1,
        gust_kph: 13.0,
        uv: 4.0,
      },
      {
        time_epoch: 1651140000,
        time: "2023-04-28 11:00",
        temp_c: 13.7,
        temp_f: 56.7,
        is_day: 1,
        condition: {
          text: "Partly cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
          code: 1003,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 64,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.45,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 50,
        cloud: 43,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.7,
        heatindex_f: 56.7,
        dewpoint_c: 3.5,
        dewpoint_f: 38.3,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651143600,
        time: "2023-04-28 12:00",
        temp_c: 14.9,
        temp_f: 58.8,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 74,
        wind_dir: "ENE",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 13,
        feelslike_c: 14.4,
        feelslike_f: 57.9,
        windchill_c: 14.4,
        windchill_f: 57.9,
        heatindex_c: 14.9,
        heatindex_f: 58.8,
        dewpoint_c: 3.8,
        dewpoint_f: 38.8,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 7.8,
        gust_kph: 12.6,
        uv: 4.0,
      },
      {
        time_epoch: 1651147200,
        time: "2023-04-28 13:00",
        temp_c: 15.6,
        temp_f: 60.1,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 85,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 11,
        feelslike_c: 15.6,
        feelslike_f: 60.1,
        windchill_c: 15.6,
        windchill_f: 60.1,
        heatindex_c: 15.6,
        heatindex_f: 60.1,
        dewpoint_c: 3.9,
        dewpoint_f: 39.0,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651150800,
        time: "2023-04-28 14:00",
        temp_c: 15.5,
        temp_f: 59.9,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 90,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 45,
        cloud: 90,
        feelslike_c: 15.5,
        feelslike_f: 59.9,
        windchill_c: 15.5,
        windchill_f: 59.9,
        heatindex_c: 15.5,
        heatindex_f: 59.9,
        dewpoint_c: 3.7,
        dewpoint_f: 38.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 4.0,
      },
      {
        time_epoch: 1651154400,
        time: "2023-04-28 15:00",
        temp_c: 15.8,
        temp_f: 60.4,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.8,
        wind_kph: 12.6,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 46,
        cloud: 9,
        feelslike_c: 15.8,
        feelslike_f: 60.4,
        windchill_c: 15.8,
        windchill_f: 60.4,
        heatindex_c: 15.8,
        heatindex_f: 60.4,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 5.0,
      },
      {
        time_epoch: 1651158000,
        time: "2023-04-28 16:00",
        temp_c: 15.3,
        temp_f: 59.5,
        is_day: 1,
        condition: {
          text: "Sunny",
          icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
          code: 1000,
        },
        wind_mph: 7.6,
        wind_kph: 12.2,
        wind_degree: 97,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.42,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 47,
        cloud: 22,
        feelslike_c: 15.3,
        feelslike_f: 59.5,
        windchill_c: 15.3,
        windchill_f: 59.5,
        heatindex_c: 15.3,
        heatindex_f: 59.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.7,
        gust_kph: 14.0,
        uv: 5.0,
      },
      {
        time_epoch: 1651161600,
        time: "2023-04-28 17:00",
        temp_c: 13.9,
        temp_f: 57.0,
        is_day: 1,
        condition: {
          text: "Cloudy",
          icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
          code: 1006,
        },
        wind_mph: 8.5,
        wind_kph: 13.7,
        wind_degree: 98,
        wind_dir: "E",
        pressure_mb: 1030.0,
        pressure_in: 30.43,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 53,
        cloud: 80,
        feelslike_c: 12.9,
        feelslike_f: 55.2,
        windchill_c: 12.9,
        windchill_f: 55.2,
        heatindex_c: 13.9,
        heatindex_f: 57.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.8,
        gust_kph: 15.8,
        uv: 3.0,
      },
      {
        time_epoch: 1651165200,
        time: "2023-04-28 18:00",
        temp_c: 12.3,
        temp_f: 54.1,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.9,
        wind_kph: 14.4,
        wind_degree: 99,
        wind_dir: "E",
        pressure_mb: 1031.0,
        pressure_in: 30.44,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 60,
        cloud: 100,
        feelslike_c: 10.8,
        feelslike_f: 51.4,
        windchill_c: 10.8,
        windchill_f: 51.4,
        heatindex_c: 12.3,
        heatindex_f: 54.1,
        dewpoint_c: 4.7,
        dewpoint_f: 40.5,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 11.2,
        gust_kph: 18.0,
        uv: 3.0,
      },
      {
        time_epoch: 1651168800,
        time: "2023-04-28 19:00",
        temp_c: 11.0,
        temp_f: 51.8,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 8.1,
        wind_kph: 13.0,
        wind_degree: 95,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.46,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 65,
        cloud: 100,
        feelslike_c: 9.4,
        feelslike_f: 48.9,
        windchill_c: 9.4,
        windchill_f: 48.9,
        heatindex_c: 11.0,
        heatindex_f: 51.8,
        dewpoint_c: 4.8,
        dewpoint_f: 40.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 10.1,
        gust_kph: 16.2,
        uv: 3.0,
      },
      {
        time_epoch: 1651172400,
        time: "2023-04-28 20:00",
        temp_c: 10.0,
        temp_f: 50.0,
        is_day: 1,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/day/122.png",
          code: 1009,
        },
        wind_mph: 7.2,
        wind_kph: 11.5,
        wind_degree: 84,
        wind_dir: "E",
        pressure_mb: 1032.0,
        pressure_in: 30.48,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 68,
        cloud: 100,
        feelslike_c: 8.4,
        feelslike_f: 47.1,
        windchill_c: 8.4,
        windchill_f: 47.1,
        heatindex_c: 10.0,
        heatindex_f: 50.0,
        dewpoint_c: 4.4,
        dewpoint_f: 39.9,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 3.0,
      },
      {
        time_epoch: 1651176000,
        time: "2023-04-28 21:00",
        temp_c: 9.4,
        temp_f: 48.9,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 76,
        wind_dir: "ENE",
        pressure_mb: 1032.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 71,
        cloud: 100,
        feelslike_c: 7.7,
        feelslike_f: 45.9,
        windchill_c: 7.7,
        windchill_f: 45.9,
        heatindex_c: 9.4,
        heatindex_f: 48.9,
        dewpoint_c: 4.3,
        dewpoint_f: 39.7,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.4,
        gust_kph: 15.1,
        uv: 1.0,
      },
      {
        time_epoch: 1651179600,
        time: "2023-04-28 22:00",
        temp_c: 9.0,
        temp_f: 48.2,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.9,
        wind_kph: 11.2,
        wind_degree: 69,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 73,
        cloud: 100,
        feelslike_c: 7.2,
        feelslike_f: 45.0,
        windchill_c: 7.2,
        windchill_f: 45.0,
        heatindex_c: 9.0,
        heatindex_f: 48.2,
        dewpoint_c: 4.5,
        dewpoint_f: 40.1,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 9.2,
        gust_kph: 14.8,
        uv: 1.0,
      },
      {
        time_epoch: 1651183200,
        time: "2023-04-28 23:00",
        temp_c: 8.6,
        temp_f: 47.5,
        is_day: 0,
        condition: {
          text: "Overcast",
          icon: "//cdn.weatherapi.com/weather/64x64/night/122.png",
          code: 1009,
        },
        wind_mph: 6.7,
        wind_kph: 10.8,
        wind_degree: 60,
        wind_dir: "ENE",
        pressure_mb: 1033.0,
        pressure_in: 30.49,
        precip_mm: 0.0,
        precip_in: 0.0,
        humidity: 74,
        cloud: 100,
        feelslike_c: 6.8,
        feelslike_f: 44.2,
        windchill_c: 6.8,
        windchill_f: 44.2,
        heatindex_c: 8.6,
        heatindex_f: 47.5,
        dewpoint_c: 4.2,
        dewpoint_f: 39.6,
        will_it_rain: 0,
        chance_of_rain: 0,
        will_it_snow: 0,
        chance_of_snow: 0,
        vis_km: 10.0,
        vis_miles: 6.0,
        gust_mph: 8.9,
        gust_kph: 14.4,
        uv: 1.0,
      },
    ],
    day: {
      maxtemp_c: 17.2,
      mintemp_c: 7.5,
      avgtemp_c: 11.8,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
      },
    },
  },
];
